import { FC } from 'react';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import CircleIcon from '../CircleIcon';
import { ISchedules } from '../../../services/journey.service';
import JourneyScheduleDotsViewModel from './viewModel';
import { JourneyDotItem, JourneyScheduleDotsVariant } from './model';
import { Row, DotColumn, DoneIcon, NextIcon } from './styled';

interface Props {
  schedules: ISchedules[];
  variant?: JourneyScheduleDotsVariant;
}

const DOT_SIZE = '40px';

const JourneyScheduleDots: FC<Props> = ({ schedules, variant = 'active' }) => {
  const theme = useTheme();
  const { dots } = JourneyScheduleDotsViewModel(schedules, variant);

  if (dots.length === 0) return null;

  const getDotAppearance = (dot: JourneyDotItem) => ({
    backgroundColor:
      variant === 'finalized'
        ? theme.palette.neutrals.beige4
        : dot.status === 'done'
          ? theme.palette.brand.mediumGreen
          : theme.palette.neutrals.beige1,
    border: dot.status === 'next',
    borderColor: theme.palette.brand.mediumGreen,
    icon: dot.status === 'done' ? <DoneIcon /> : <NextIcon />
  });

  return (
    <Row>
      {dots.map(dot => (
        <DotColumn key={dot.id}>
          {dot.kind === 'collapsed' ? (
            <CircleIcon
              size={DOT_SIZE}
              backgroundColor={theme.palette.neutrals.beige3}
              icon={
                <Typography variant="body1B" color="brand.darkGreen">
                  +{dot.count}
                </Typography>
              }
            />
          ) : (
            <CircleIcon size={DOT_SIZE} {...getDotAppearance(dot)} />
          )}
          <Typography variant="body7" color="brand.darkGreen">
            {dot.label}
          </Typography>
        </DotColumn>
      ))}
    </Row>
  );
};

export default JourneyScheduleDots;
